import React, { useState, useEffect } from "react";
import styles from "./Settings.module.css";
import AxiosUrl from "../AxiosUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AiOutlineMobile,
  AiOutlineCreditCard,
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineSave,
} from "react-icons/ai";

const Settings = () => {
  const uid = localStorage.getItem("id");

  // API Settings State
  const [apiSettings, setApiSettings] = useState({
    smsApiKey: "",
    smsSenderNumber: "",
    smsEnabled: false,
    bkashApiKey: "",
    bkashSecretKey: "",
    bkashEnabled: false,
    sslCommerzApiKey: "",
    sslCommerzSecretKey: "",
    sslCommerzEnabled: false,
    amarPayApiKey: "",
    amarPaySecretKey: "",
    amarPayEnabled: false,
    rocketApiKey: "",
    rocketSecretKey: "",
    rocketEnabled: false,
    nogodApiKey: "",
    nogodSecretKey: "",
    nogodEnabled: false,
    stripeApiKey: "",
    stripeSecretKey: "",
    stripeEnabled: false,
    paypalApiKey: "",
    paypalSecretKey: "",
    paypalEnabled: false,
  });

  const [showApiKeys, setShowApiKeys] = useState({});
  const [loading, setLoading] = useState(true);

  const handleApiChange = (e) => {
    const { name, value, type, checked } = e.target;
    setApiSettings({
      ...apiSettings,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const toggleApiKeyVisibility = (key) => {
    setShowApiKeys({ ...showApiKeys, [key]: !showApiKeys[key] });
  };

  const handleSMSSubmit = (e) => {
    e.preventDefault();
    console.log("SMS Settings:", {
      smsApiKey: apiSettings.smsApiKey,
      smsSenderNumber: apiSettings.smsSenderNumber,
      smsEnabled: apiSettings.smsEnabled,
    });
    toast.success("SMS Settings saved successfully!");
  };

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    console.log("Payment Settings:", apiSettings);
    toast.success("Payment Gateway Settings saved successfully!");
  };

  useEffect(() => {
    // Load API settings from backend
    AxiosUrl.get(`api-settings/${uid}`)
      .then((res) => {
        if (res.data) {
          setApiSettings(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [uid]);

  return (
    <div className={styles["settings-page-container"]}>
      <ToastContainer />

      {/* SMS API Settings */}
      <div className={styles["settings-section"]}>
        <div className={styles["section-header"]}>
          <AiOutlineMobile className={styles["header-icon"]} />
          <h2 className={styles["section-title"]}>SMS API Configuration</h2>
        </div>
        {loading ? (
          <div style={{padding: '28px'}}>
            {/* Toggle row */}
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb', marginBottom: '20px'}}>
              <div className={styles.skeleton} style={{width: '130px', height: '16px'}}></div>
              <div className={styles.skeleton} style={{width: '52px', height: '28px', borderRadius: '14px'}}></div>
            </div>
            {/* Form row */}
            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px'}}>
              <div>
                <div className={styles.skeleton} style={{width: '90px', height: '14px', marginBottom: '8px'}}></div>
                <div className={styles.skeleton} style={{width: '100%', height: '44px', borderRadius: '8px'}}></div>
              </div>
              <div>
                <div className={styles.skeleton} style={{width: '130px', height: '14px', marginBottom: '8px'}}></div>
                <div className={styles.skeleton} style={{width: '100%', height: '44px', borderRadius: '8px'}}></div>
              </div>
            </div>
            {/* Save button */}
            <div className={styles.skeleton} style={{width: '100%', height: '48px', borderRadius: '8px', marginTop: '20px'}}></div>
          </div>
        ) : (
        <form onSubmit={handleSMSSubmit} className={styles["settings-form"]}>
          <div className={styles["toggle-section"]}>
            <div className={styles["toggle-header"]}>
              <label className={styles["toggle-label"]}>Enable SMS API</label>
              <label className={styles["toggle-switch"]}>
                <input
                  type="checkbox"
                  name="smsEnabled"
                  checked={apiSettings.smsEnabled}
                  onChange={handleApiChange}
                />
                <span className={styles["toggle-slider"]}></span>
              </label>
            </div>
          </div>

          {apiSettings.smsEnabled && (
            <>
              <div className={styles["form-row"]}>
                <div className={styles["form-group"]}>
                  <label htmlFor="smsApiKey">SMS API Key</label>
                  <div className={styles["input-with-icon"]}>
                    <input
                      type={showApiKeys.smsApiKey ? "text" : "password"}
                      id="smsApiKey"
                      name="smsApiKey"
                      placeholder="Enter SMS API Key"
                      value={apiSettings.smsApiKey}
                      onChange={handleApiChange}
                    />
                    <button
                      type="button"
                      className={styles["visibility-btn"]}
                      onClick={() => toggleApiKeyVisibility("smsApiKey")}
                    >
                      {showApiKeys.smsApiKey ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </button>
                  </div>
                </div>
                <div className={styles["form-group"]}>
                  <label htmlFor="smsSenderNumber">SMS Sender Number</label>
                  <input
                    type="text"
                    id="smsSenderNumber"
                    name="smsSenderNumber"
                    placeholder="Enter Sender Number"
                    value={apiSettings.smsSenderNumber}
                    onChange={handleApiChange}
                  />
                </div>
              </div>
            </>
          )}

          <button type="submit" className={styles["btn-primary"]}>
            <AiOutlineSave className={styles["btn-icon"]} />
            Save SMS Settings
          </button>
        </form>
        )}
      </div>

      {/* Payment Gateway Settings */}
      <div className={styles["settings-section"]}>
        <div className={styles["section-header"]}>
          <AiOutlineCreditCard className={styles["header-icon"]} />
          <h2 className={styles["section-title"]}>
            Payment Gateway Configuration
          </h2>
        </div>
        {loading ? (
          <div style={{padding: '28px'}}>
            {/* Payment gateways */}
            {[1, 2, 3, 4].map((i) => (
              <div key={i} style={{marginBottom: '24px', paddingBottom: '24px', borderBottom: i < 4 ? '1px solid #f4f6f8' : 'none'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb'}}>
                  <div>
                    <div className={styles.skeleton} style={{width: '80px', height: '16px', marginBottom: '6px'}}></div>
                    <div className={styles.skeleton} style={{width: '200px', height: '13px'}}></div>
                  </div>
                  <div className={styles.skeleton} style={{width: '52px', height: '28px', borderRadius: '14px'}}></div>
                </div>
              </div>
            ))}
            {/* Save button */}
            <div className={styles.skeleton} style={{width: '100%', height: '48px', borderRadius: '8px', marginTop: '20px'}}></div>
          </div>
        ) : (
        <form onSubmit={handlePaymentSubmit} className={styles["settings-form"]}>
          {/* bKash */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>bKash</h3>
                  <p className={styles["gateway-desc"]}>
                    Bangladesh's leading mobile financial service
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="bkashEnabled"
                    checked={apiSettings.bkashEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.bkashEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="bkashApiKey">API Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.bkashApiKey ? "text" : "password"}
                        id="bkashApiKey"
                        name="bkashApiKey"
                        placeholder="Enter bKash API Key"
                        value={apiSettings.bkashApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() => toggleApiKeyVisibility("bkashApiKey")}
                      >
                        {showApiKeys.bkashApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="bkashSecretKey">Secret Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.bkashSecretKey ? "text" : "password"
                        }
                        id="bkashSecretKey"
                        name="bkashSecretKey"
                        placeholder="Enter bKash Secret Key"
                        value={apiSettings.bkashSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("bkashSecretKey")
                        }
                      >
                        {showApiKeys.bkashSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* SSL Commerz */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>SSL Commerz</h3>
                  <p className={styles["gateway-desc"]}>
                    Secure payment gateway for Bangladesh
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="sslCommerzEnabled"
                    checked={apiSettings.sslCommerzEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.sslCommerzEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="sslCommerzApiKey">Store ID</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.sslCommerzApiKey ? "text" : "password"
                        }
                        id="sslCommerzApiKey"
                        name="sslCommerzApiKey"
                        placeholder="Enter SSL Commerz Store ID"
                        value={apiSettings.sslCommerzApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("sslCommerzApiKey")
                        }
                      >
                        {showApiKeys.sslCommerzApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="sslCommerzSecretKey">Store Password</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.sslCommerzSecretKey ? "text" : "password"
                        }
                        id="sslCommerzSecretKey"
                        name="sslCommerzSecretKey"
                        placeholder="Enter Store Password"
                        value={apiSettings.sslCommerzSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("sslCommerzSecretKey")
                        }
                      >
                        {showApiKeys.sslCommerzSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* AmarPay */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>AmarPay</h3>
                  <p className={styles["gateway-desc"]}>
                    Digital payment solution for Bangladesh
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="amarPayEnabled"
                    checked={apiSettings.amarPayEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.amarPayEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="amarPayApiKey">Merchant ID</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.amarPayApiKey ? "text" : "password"}
                        id="amarPayApiKey"
                        name="amarPayApiKey"
                        placeholder="Enter AmarPay Merchant ID"
                        value={apiSettings.amarPayApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("amarPayApiKey")
                        }
                      >
                        {showApiKeys.amarPayApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="amarPaySecretKey">Secret Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.amarPaySecretKey ? "text" : "password"
                        }
                        id="amarPaySecretKey"
                        name="amarPaySecretKey"
                        placeholder="Enter Secret Key"
                        value={apiSettings.amarPaySecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("amarPaySecretKey")
                        }
                      >
                        {showApiKeys.amarPaySecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Rocket */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>Rocket</h3>
                  <p className={styles["gateway-desc"]}>
                    Dutch-Bangla Bank mobile financial service
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="rocketEnabled"
                    checked={apiSettings.rocketEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.rocketEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="rocketApiKey">API Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.rocketApiKey ? "text" : "password"}
                        id="rocketApiKey"
                        name="rocketApiKey"
                        placeholder="Enter Rocket API Key"
                        value={apiSettings.rocketApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() => toggleApiKeyVisibility("rocketApiKey")}
                      >
                        {showApiKeys.rocketApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="rocketSecretKey">Secret Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.rocketSecretKey ? "text" : "password"
                        }
                        id="rocketSecretKey"
                        name="rocketSecretKey"
                        placeholder="Enter Secret Key"
                        value={apiSettings.rocketSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("rocketSecretKey")
                        }
                      >
                        {showApiKeys.rocketSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Nagad */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>Nagad</h3>
                  <p className={styles["gateway-desc"]}>
                    Digital financial service by Bangladesh Post Office
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="nogodEnabled"
                    checked={apiSettings.nogodEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.nogodEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="nogodApiKey">Merchant ID</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.nogodApiKey ? "text" : "password"}
                        id="nogodApiKey"
                        name="nogodApiKey"
                        placeholder="Enter Nagad Merchant ID"
                        value={apiSettings.nogodApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() => toggleApiKeyVisibility("nogodApiKey")}
                      >
                        {showApiKeys.nogodApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="nogodSecretKey">Public Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.nogodSecretKey ? "text" : "password"}
                        id="nogodSecretKey"
                        name="nogodSecretKey"
                        placeholder="Enter Public Key"
                        value={apiSettings.nogodSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("nogodSecretKey")
                        }
                      >
                        {showApiKeys.nogodSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Stripe */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>Stripe</h3>
                  <p className={styles["gateway-desc"]}>
                    International payment processing platform
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="stripeEnabled"
                    checked={apiSettings.stripeEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.stripeEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="stripeApiKey">Publishable Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.stripeApiKey ? "text" : "password"}
                        id="stripeApiKey"
                        name="stripeApiKey"
                        placeholder="Enter Stripe Publishable Key"
                        value={apiSettings.stripeApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() => toggleApiKeyVisibility("stripeApiKey")}
                      >
                        {showApiKeys.stripeApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="stripeSecretKey">Secret Key</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.stripeSecretKey ? "text" : "password"
                        }
                        id="stripeSecretKey"
                        name="stripeSecretKey"
                        placeholder="Enter Secret Key"
                        value={apiSettings.stripeSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("stripeSecretKey")
                        }
                      >
                        {showApiKeys.stripeSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* PayPal */}
          <div className={styles["payment-gateway"]}>
            <div className={styles["toggle-section"]}>
              <div className={styles["toggle-header"]}>
                <div className={styles["gateway-info"]}>
                  <h3 className={styles["gateway-name"]}>PayPal</h3>
                  <p className={styles["gateway-desc"]}>
                    Global online payment system
                  </p>
                </div>
                <label className={styles["toggle-switch"]}>
                  <input
                    type="checkbox"
                    name="paypalEnabled"
                    checked={apiSettings.paypalEnabled}
                    onChange={handleApiChange}
                  />
                  <span className={styles["toggle-slider"]}></span>
                </label>
              </div>
            </div>

            {apiSettings.paypalEnabled && (
              <div className={styles["gateway-credentials"]}>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="paypalApiKey">Client ID</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={showApiKeys.paypalApiKey ? "text" : "password"}
                        id="paypalApiKey"
                        name="paypalApiKey"
                        placeholder="Enter PayPal Client ID"
                        value={apiSettings.paypalApiKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() => toggleApiKeyVisibility("paypalApiKey")}
                      >
                        {showApiKeys.paypalApiKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className={styles["form-group"]}>
                    <label htmlFor="paypalSecretKey">Client Secret</label>
                    <div className={styles["input-with-icon"]}>
                      <input
                        type={
                          showApiKeys.paypalSecretKey ? "text" : "password"
                        }
                        id="paypalSecretKey"
                        name="paypalSecretKey"
                        placeholder="Enter Client Secret"
                        value={apiSettings.paypalSecretKey}
                        onChange={handleApiChange}
                      />
                      <button
                        type="button"
                        className={styles["visibility-btn"]}
                        onClick={() =>
                          toggleApiKeyVisibility("paypalSecretKey")
                        }
                      >
                        {showApiKeys.paypalSecretKey ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button type="submit" className={styles["btn-primary"]}>
            <AiOutlineSave className={styles["btn-icon"]} />
            Save Payment Settings
          </button>
        </form>
        )}
      </div>
    </div>
  );
};

export default Settings;
